import React from 'react';
import { MapPinIcon, PhoneIcon, MailIcon, InstagramIcon, FacebookIcon, LinkedinIcon, CalendarIcon, MessageCircleIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#000000] border-t border-[#50C878]/20 pt-16 pb-8 text-sm" data-id="element-86">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-87">
        {/* Top 4 Columns */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-88">
          {/* Column 1: Brand */}
          <div className="space-y-6" data-id="element-89">
            <div className="flex items-center gap-2" data-id="element-90">
              <div className="w-8 h-8 bg-[#50C878] rounded-sm flex items-center justify-center text-black font-bold text-xs shadow-[0_0_10px_rgba(80,200,120,0.5)]" data-id="element-91">
                DE
              </div>
              <span className="text-white font-bold text-lg tracking-wider" data-id="element-92">
                DOCTOR ECOMMERCE
              </span>
            </div>
            <h3 className="text-[#FFD700] font-bold text-lg drop-shadow-[0_0_5px_rgba(255,215,0,0.3)]" data-id="element-93">
              La cura para negocios estancados.
            </h3>
            <p className="text-[#C0C0C0] leading-relaxed" data-id="element-94">
              En Doctor Ecommerce no gestionamos redes, operamos sistemas de
              adquisición de alto rendimiento. Con sede estratégica en Tampa,
              Florida, servimos a dueños de negocios en todo Estados Unidos,
              transformando presupuestos publicitarios en máquinas de generación
              de llamadas y ventas diarias.
            </p>
            <div className="flex gap-4" data-id="element-95">
              <a href="#" className="text-[#50C878] hover:text-white transition-colors" data-id="element-96">
                <InstagramIcon className="w-5 h-5" data-id="element-97" />
              </a>
              <a href="#" className="text-[#50C878] hover:text-white transition-colors" data-id="element-98">
                <FacebookIcon className="w-5 h-5" data-id="element-99" />
              </a>
              <a href="#" className="text-[#50C878] hover:text-white transition-colors" data-id="element-100">
                <LinkedinIcon className="w-5 h-5" data-id="element-101" />
              </a>
              <a href="#" className="text-[#50C878] hover:text-white transition-colors font-bold text-lg leading-none" data-id="element-102">
                tik<span className="text-xs align-top" data-id="element-103">tok</span>
              </a>
            </div>
          </div>

          {/* Column 2: Services */}
          <div data-id="element-104">
            <h4 className="text-[#50C878] font-bold mb-6 tracking-wider" data-id="element-105">
              SERVICIOS
            </h4>
            <ul className="space-y-4 text-[#C0C0C0]" data-id="element-106">
              <li className="hover:text-white transition-colors cursor-pointer" data-id="element-107">
                Meta Ads · Google Ads · TikTok Ads · YouTube Ads
              </li>
              <li className="hover:text-white transition-colors cursor-pointer" data-id="element-108">
                Email · SMS · Retargeting Automatizado
              </li>
              <li className="hover:text-white transition-colors cursor-pointer" data-id="element-109">
                Automatización con IA para Ventas 24/7
              </li>
              <li className="hover:text-white transition-colors cursor-pointer" data-id="element-110">
                Funnels Quirúrgicos por Industria
              </li>
              <li className="hover:text-white transition-colors cursor-pointer" data-id="element-111">
                Blindaje Digital & Anti-Ban
              </li>
              <li className="hover:text-white transition-colors cursor-pointer" data-id="element-112">
                PR Digital & Posicionamiento en Medios
              </li>
              <li className="hover:text-white transition-colors cursor-pointer" data-id="element-113">
                CRM & Data Tracking Avanzado
              </li>
              <li className="hover:text-white transition-colors cursor-pointer" data-id="element-114">
                Video Marketing IA · SEO · Branding
              </li>
              <li className="hover:text-white transition-colors cursor-pointer" data-id="element-115">
                Gestión de Reputación · Google Maps
              </li>
              <li className="hover:text-white transition-colors cursor-pointer" data-id="element-116">
                Diseño Web · Landing Pages · CRO
              </li>
            </ul>
          </div>

          {/* Column 3: Resources */}
          <div data-id="element-117">
            <h4 className="text-[#50C878] font-bold mb-6 tracking-wider" data-id="element-118">
              RECURSOS
            </h4>
            <ul className="space-y-4 text-[#C0C0C0]" data-id="element-119">
              <li className="flex items-center gap-2 hover:text-white transition-colors cursor-pointer" data-id="element-120">
                <span className="text-xs text-[#50C878]" data-id="element-121">›</span> Blog de
                Estrategia
              </li>
              <li className="flex items-center gap-2 hover:text-white transition-colors cursor-pointer" data-id="element-122">
                <span className="text-xs text-[#50C878]" data-id="element-123">›</span> Casos de Éxito
              </li>
              <li className="flex items-center gap-2 hover:text-white transition-colors cursor-pointer" data-id="element-124">
                <span className="text-xs text-[#50C878]" data-id="element-125">›</span> Política de
                Privacidad
              </li>
              <li className="flex items-center gap-2 hover:text-white transition-colors cursor-pointer" data-id="element-126">
                <span className="text-xs text-[#50C878]" data-id="element-127">›</span> Términos y
                Condiciones
              </li>
            </ul>
          </div>

          {/* Column 4: Contact */}
          <div className="space-y-6" data-id="element-128">
            <h4 className="text-[#50C878] font-bold mb-6 tracking-wider" data-id="element-129">
              CONTACTO DIRECTO
            </h4>
            <ul className="space-y-4 text-white font-medium" data-id="element-130">
              <li className="flex items-start gap-3" data-id="element-131">
                <MapPinIcon className="w-5 h-5 text-[#50C878] shrink-0 mt-0.5" data-id="element-132" />
                <span data-id="element-133">1001 WATER ST, TAMPA FL 33602</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-134">
                <PhoneIcon className="w-5 h-5 text-[#50C878] shrink-0" data-id="element-135" />
                <span data-id="element-136">402-872-0639</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-137">
                <MailIcon className="w-5 h-5 text-[#50C878] shrink-0" data-id="element-138" />
                <span data-id="element-139">doctor.ecommerceus@gmail.com</span>
              </li>
            </ul>

            <div className="pt-4 space-y-3" data-id="element-140">
              <a href="https://wa.me/14028720639" target="_blank" rel="noopener noreferrer" className="w-full bg-[#50C878] hover:bg-[#3da862] text-black font-bold py-3 px-4 rounded flex items-center justify-center gap-2 transition-colors shadow-[0_0_15px_rgba(80,200,120,0.3)]" data-id="element-141">
                <MessageCircleIcon className="w-5 h-5" data-id="element-142" />
                Habla con un Especialista
              </a>
              <a href="https://calendar.app.google/gDsqAVqmwUYm" target="_blank" rel="noopener noreferrer" className="w-full bg-[#FFD700] hover:bg-[#e6c200] text-black font-bold py-3 px-4 rounded flex items-center justify-center gap-2 transition-colors neon-glow" data-id="element-143">
                <CalendarIcon className="w-5 h-5" data-id="element-144" />
                RESERVAR DIAGNÓSTICO
              </a>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px w-full bg-[#50C878]/20 mb-12" data-id="element-145"></div>

        {/* Bottom Bar: Partners & Form */}
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end gap-12" data-id="element-146">
          {/* Partners */}
          <div className="w-full lg:w-auto" data-id="element-147">
            <h5 className="text-[#C0C0C0] font-bold tracking-widest text-xs mb-4 uppercase" data-id="element-148">
              Partners Certificados y Tecnología de Élite
            </h5>
            <div className="flex flex-wrap gap-3" data-id="element-149">
              <div className="bg-white rounded px-4 py-2 flex items-center justify-center h-10 min-w-[80px]" data-id="element-150">
                <span className="text-black text-[10px] font-bold" data-id="element-151">Meta</span>
              </div>
              <div className="bg-white rounded px-4 py-2 flex items-center justify-center h-10 min-w-[80px]" data-id="element-152">
                <span className="text-black text-[10px] font-bold" data-id="element-153">
                  Google Ads
                </span>
              </div>
              <div className="bg-white rounded px-4 py-2 flex items-center justify-center h-10 min-w-[80px]" data-id="element-154">
                <span className="text-black text-[10px] font-bold" data-id="element-155">
                  CERTIFIED
                </span>
              </div>
              <div className="bg-white rounded px-4 py-2 flex items-center justify-center h-10 min-w-[80px]" data-id="element-156">
                <span className="text-black text-[10px] font-bold" data-id="element-157">
                  Shopify
                </span>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="w-full lg:w-auto flex-1 max-w-4xl" data-id="element-158">
            <h5 className="text-[#C0C0C0] font-bold tracking-widest text-xs mb-4 uppercase" data-id="element-159">
              ¿Quieres que te contactemos?
            </h5>
            <form className="flex flex-wrap gap-3" onSubmit={e => e.preventDefault()} data-id="element-160">
              <input type="text" placeholder="Tu Nombre" className="flex-1 min-w-[150px] bg-[#111111] border border-white/10 rounded px-4 py-2.5 text-white placeholder:text-gray-600 focus:outline-none focus:border-[#50C878] focus:shadow-[0_0_10px_rgba(80,200,120,0.3)] transition-all" data-id="element-161" />
              <input type="email" placeholder="Tu Email" className="flex-1 min-w-[150px] bg-[#111111] border border-white/10 rounded px-4 py-2.5 text-white placeholder:text-gray-600 focus:outline-none focus:border-[#50C878] focus:shadow-[0_0_10px_rgba(80,200,120,0.3)] transition-all" data-id="element-162" />
              <input type="tel" placeholder="Tu Teléfono" className="flex-1 min-w-[150px] bg-[#111111] border border-white/10 rounded px-4 py-2.5 text-white placeholder:text-gray-600 focus:outline-none focus:border-[#50C878] focus:shadow-[0_0_10px_rgba(80,200,120,0.3)] transition-all" data-id="element-163" />
              <input type="text" placeholder="Nombre de tu Empresa" className="flex-1 min-w-[150px] bg-[#111111] border border-white/10 rounded px-4 py-2.5 text-white placeholder:text-gray-600 focus:outline-none focus:border-[#50C878] focus:shadow-[0_0_10px_rgba(80,200,120,0.3)] transition-all" data-id="element-164" />
              <button type="submit" className="bg-[#FFD700] hover:bg-[#e6c200] text-black font-bold px-8 py-2.5 rounded transition-colors neon-glow" data-id="element-165">
                ENVIAR
              </button>
            </form>
          </div>
        </div>
      </div>
    </footer>;
}